<template>
    <div class="modal fade" id="modal_add_payment_service" tabindex="-1" data-bs-backdrop='static' aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content position-relative">
                <loader-gif v-if="isRequestPayment" />
                <div class="modal-header">
                    <h5 class="modal-title" id="varyingModalLabel">
                        {{ i18n.t('views.clients.income.payment.title') }}

                    </h5>
                    <button @click="closeModal('modal_add_payment_service', 'add')" type="button" class="btn-close"
                        aria-label="btn-close"></button>
                </div>
                <div class="modal-body" v-if="requestPaymentIncome">
                    <form class="forms-sample" @submit.prevent="submitForm">

                        <div class="row mb-3">
                            <div class="col-md-12">
                                <h4 class="title-h4">
                                    {{ i18n.t('views.clients.income.payment.info') }}
                                </h4>
                            </div>
                        </div>
                        <!-- information income (rocette) -->
                        <informations-income />
                        <!-- end information income (rocette) -->


                        <hr>


                        <div class="row ">
                            <div class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <date-field v-model="requestPaymentIncome.paymentDate"
                                        :label="i18n.t('tables.payment.paymentDate')" :v="v$.paymentDate"
                                        :disabled="false" :fixedDays="1" :isFixedDays="true" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <SingleSelect :TextLabel="i18n.t('tables.payment.paymentMethod')" :trackby="`id`"
                                    :label="`name`" :valueProp="`id`" v-model="requestPaymentIncome.paymentMethod"
                                    :placeholder="i18n.t('tables.payment.paymentMethod')"
                                    :arrayOptions="payment_methodsList" refs="paymentMethod" :v="v$.paymentMethod" />
                            </div>
                            <div v-if="requestPaymentIncome.paymentMethod === 'Chèque bancaire'" class="col-md-6">
                                <SingleSelect :TextLabel="i18n.t('tables.payment.bankName')" :trackby="`id`"
                                    :label="`name`" :valueProp="`id`" v-model="requestPaymentIncome.bankName"
                                    :placeholder="i18n.t('tables.payment.bankName')" :arrayOptions="bank_namesList"
                                    refs="bankName" :v="v$.bankName" />
                            </div>

                            <div v-if="requestPaymentIncome.paymentMethod === 'Chèque bancaire'" class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <inputText v-model="requestPaymentIncome.chequeName"
                                        :label="i18n.t('tables.payment.chequeName')" :v="v$.chequeName"
                                        :disabled="false" />
                                </div>
                            </div>
                            <div v-if="requestPaymentIncome.paymentMethod === 'Chèque bancaire'" class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <inputText v-model="requestPaymentIncome.chequeNum"
                                        :label="i18n.t('tables.payment.chequeNum')" :v="v$.chequeNum"
                                        :disabled="false" />
                                </div>
                            </div>

                            <div v-if="requestPaymentIncome.paymentMethod === 'Chèque bancaire'" class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <date-field v-model="requestPaymentIncome.dueDate"
                                        :label="i18n.t('tables.payment.dueDate')" :v="v$.dueDate" :disabled="false"
                                        :fixedDays="1" :isFixedDays="false" />
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <price-input v-model="requestPaymentIncome.amount_paid"
                                        :label="i18n.t('tables.payment.amount_paid')" :v="v$.amount_paid"
                                        :disabled="false" />
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-right">
                            <button type="submit" class="btn btn-primary mr-2">
                                {{ action == 'add' ? i18n.t('button.add') : i18n.t('button.edit') }}
                            </button>
                            <button type="button" @click="emptyState()" class="btn btn-cancel">
                                {{ i18n.t('button.cancel') }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import { defineComponent, ref, computed, watch, reactive, toRefs, Ref } from "vue";
/*Components*/
import inputText from "@/components/inputsValidation/ReusableInput.vue";
import SingleSelect from "@/components/inputsValidation/SingleSelect.vue";
import checkboxInput from "@/components/inputsValidation/checkboxInput.vue";
import inputTextarea from "@/components/inputsValidation/ReusableTextarea.vue";



/*plugins*/
import { useVuelidate } from "@vuelidate/core";
import { required, numeric, minLength, minValue, helpers, requiredIf } from "@vuelidate/validators";
import Swal from "sweetalert2";
import i18n from "@/i18n/index"
import dayjs from 'dayjs';

/*composables & states */
import { useModal } from '@/composables/modal/useModal';
import { usePayment } from "@/composables/payment/usePayment";
import { clubUUID, bank_names, payment_methods, singleIncome } from "@/shared/state";
import { Income } from "@/interfaces/income";
import { PaymentRequest, Payment } from "@/interfaces/payment";
import { useGlobal } from "@/composables/global/useGlobal";

export default defineComponent({
    components: { inputText, SingleSelect, checkboxInput, inputTextarea },
    name: "SomeComponent",
    emits: ['savedPayment'],
    setup(props, { emit }) {
        const income = computed(() => singleIncome.data);
        const action = ref('add')
        const remaining_amount = ref(0)
        const { formatDate } = useGlobal();

        const requestPaymentIncome = ref<PaymentRequest>({ 

            id: null,
            amount_paid: null,
            paymentMethod: null,
            bankName: null,
            chequeName: null,
            chequeNum: null,
            dueDate: null,
            paymentDate: dayjs(new Date()).format('YYYY-MM-DD'),
            status: "paid",
            pack_id: null,
            subscription_id: null,
            member_subscription_id: null,
            clubUUID: clubUUID.value,
            memberUUID: null,
            reference_id: income?.value?.id ?? null,
            reference_type: "services"
        });


        const bank_namesList = computed(() => bank_names.value);
        const payment_methodsList = computed(() => payment_methods.value);
        const { closeModal } = useModal();

        const { regulationSubscription, isRequestPayment  } = usePayment();


        // Validation 
        const rules = {
            clubUUID: {
                required: helpers.withMessage(i18n.t("validation.required"), required)
            },
            reference_id: {
                required: helpers.withMessage(i18n.t("validation.required"), required)
            },

            paymentMethod: {
                required: helpers.withMessage(i18n.t("validation.required"), required)
            },
            paymentDate: {
                required: helpers.withMessage(i18n.t("validation.required"), required)
            },
            bankName: {
                requiredIf: helpers.withMessage(i18n.t("validation.required"), requiredIf(() => requestPaymentIncome?.value?.paymentMethod === 'Chèque bancaire'))
            },
            chequeName: {
                requiredIf: helpers.withMessage(i18n.t("validation.required"), requiredIf(() => requestPaymentIncome?.value?.paymentMethod === 'Chèque bancaire'))
            },
            chequeNum: {
                requiredIf: helpers.withMessage(i18n.t("validation.required"), requiredIf(() => requestPaymentIncome?.value?.paymentMethod === 'Chèque bancaire'))
            },
            dueDate: {
                requiredIf: helpers.withMessage(i18n.t("validation.required"), requiredIf(() => requestPaymentIncome?.value?.paymentMethod === 'Chèque bancaire')),
            },

            amount_paid: {
                requiredIf: helpers.withMessage(i18n.t("validation.required"), requiredIf(() => requestPaymentIncome?.value?.paymentMethod !== null)),
                numeric,
                paidAmountValid: helpers.withMessage(
                    i18n.t("validation.amountExceededError"),
                    (value) => {
                        const numberValue = Number(value);
                        const TTamount = remaining_amount.value || 0
                        return numberValue !== null && numberValue <= TTamount;
                    }
                )
            }

        };
        const v$ = useVuelidate(rules, requestPaymentIncome as Ref<Required<PaymentRequest>>, { $scope: 'payment-icome' });

        /**
         * Add or edit Service
         */
        const submitForm = async () => {
            v$.value.$touch();
            if (!v$.value.$invalid) {
                if (action.value === "add") {
                    await regulationSubscription(requestPaymentIncome.value).then((res) => { 
                        if (res?.data) {
                            emit('savedPayment') 
                            emptyState()
                        }
                       
                    })

                  

                } 
            }
        }


        const emptyState = () => {
            action.value = 'add';
            requestPaymentIncome.value.id = null

            requestPaymentIncome.value.bankName = null
            requestPaymentIncome.value.chequeName = null
            requestPaymentIncome.value.chequeNum = null
            requestPaymentIncome.value.amount_paid = null
            requestPaymentIncome.value.dueDate = null
            requestPaymentIncome.value.paymentMethod = null
            requestPaymentIncome.value.paymentDate = dayjs(new Date()).format('YYYY-MM-DD')
            v$.value.$reset();
            closeModal('modal_add_payment_service', 'add')
        };






        watch(
            () => income.value,
            (newValue) => {
                requestPaymentIncome.value.reference_id = income?.value?.id ?? null

                remaining_amount.value = income?.value?.remaining_amount ?? 0

            });



        return {
            income,
            requestPaymentIncome,
            submitForm,
            emptyState,
            action,
            v$,
            i18n,
            bank_namesList,
            payment_methodsList,
            closeModal,
            remaining_amount,
            isRequestPayment,
            formatDate
        };
    },
});
</script>
